import { default as AxiosIns } from "axios";
import Cookies from "js-cookie";
import { getStore } from "app/configureStore";
import { BRANDS } from "app/constants";

const axios = AxiosIns.create();

axios.interceptors.request.use(
	config => {
		const shop = window?.location?.pathname?.split("/")[1];
		const token = Cookies.get("authToken", { path: `/${shop}` });

		const authorization = config?.headers?.Authorization;

		if (token && !authorization) {
			config.headers.Authorization = token;
		}

		// https://perfectstay.atlassian.net/browse/FBR-3773
		const brandCode = getStore().getState()?.brand?.code;
		const showSessionV2 = [BRANDS.CD, BRANDS.TO].includes(brandCode);
		if (showSessionV2) {
			config.headers["pfs-session-variant"] = "v2";
		}

		return config;
	},
	error => {
		return Promise.reject(error);
	}
);

export default axios;
